import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LoadingMore from '@src/mobile/components/LoadingMore';
import styles from './index.css';
import { Store } from '../store';
import Comment from '../Comment';
import { POSITION_MAIN } from '../constants';
import { getList } from '../utils';
import NoData from '../Nodata';
import Loading from '../Loading';
import ReplyBtn from '../ReplyBtn';

const COMMENT_PAGE_SIZE = 10;

const List = ({ subjectId }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { list, page, topIdList, docMeta } = states;

    const [initDone, setInitDone] = useState(false);

    const initData = async () => {
        const { list } = await getList({
            subjectId,
            page: 1,
            pageSize: COMMENT_PAGE_SIZE,
            sort: {},
            docUrl: docMeta?.docUrl,
        });

        if (list && Array.isArray(list) && list.length) {
            const topIdList = list.map(item => item.id);

            changeStates({ list, topIdList, page: 2 });
        }
    };

    useEffect(() => {
        initData().finally(() => {
            setInitDone(true);
        });
    }, []);

    const control = async () => {
        let statusText = 'error';

        const { list: newList, current, pageSize, total } = await getList({
            subjectId,
            page,
            pageSize: COMMENT_PAGE_SIZE,
            sort: {},
            docUrl: docMeta?.docUrl,
        });

        if (newList && Array.isArray(newList)) {
            if (current * pageSize >= total) {
                statusText = 'end';
            } else {
                statusText = 'success';
            }

            const filterList = newList.filter(item => !topIdList.find(id => id === item.id));

            changeStates({ list: [...list, ...filterList], total, page: current + 1 });
        }

        return statusText;
    };

    return (
        <>
            {initDone ? (
                <div className={styles.wrap}>
                    {list.length ? (
                        <>
                            <div className={styles.list}>
                                {list.map(item => <Comment key={item.id} content={item} position={POSITION_MAIN} />)}
                            </div>
                            <LoadingMore control={control} />
                        </>
                    ) : (
                        <NoData />
                    )}
                    <ReplyBtn subjectId={subjectId} />
                </div>
            ) : (
                <Loading />
            )}
        </>
    );
};

List.propTypes = {
    subjectId: PropTypes.string,
};

export default errorBoundary(List);
